import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./Navbar.css"; // Add CSS styling for the navbar

const Navbar = () => {
  const location = useLocation();

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <span className="navbar-mark" aria-hidden="true">CL</span>
          <span>Caltrain Live</span>
        </Link>
        <ul className="navbar-links">
          <li>
            <Link
              to="/"
              className={`navbar-link ${
                location.pathname === "/" ? "active" : ""
              }`}
            >
              Live trains
            </Link>
          </li>
          <li>
            <Link
              to="/planner"
              className={`navbar-link ${
                location.pathname.startsWith("/planner") ? "active" : ""
              }`}
            >
              Trip Planner
            </Link>
          </li>
        </ul>
        <span className="navbar-status"><span className="live-dot" />Live</span>
      </div>
    </nav>
  );
};

export default Navbar;
